import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpHandlerService } from "../../http-handler.service";
import { AppTokenService } from "../../app-token.service";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })

export class ConfigService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getResourceEndPoint = 'configs';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAll(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}?searchkey=${params?.searchkey}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public ManageConfigs(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public getAllGlobalConfig(): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/globalconfig`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public updateGlobalConfig(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/globalconfig`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public getModuleConfigByClientId(): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/moduleconfig`;
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );

        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public updateFocusConfig(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/focusconfig`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }
}